export default class CallFiltersViewModel {
    isActive: boolean = false;
    result: string[] = [];
    resultExclude: boolean = false;
    oppToSell: boolean = false;
    notOppToSell: boolean = false;
    resultSource: string = '';
    callLengthMin: number = 0;
    callLengthMax: number = 3660;
    systemID: string = '';
    isCallLengthFlag: boolean = false;
}